const Footer = () => {
  return(
    <div className="footer">
      <p>Created by Grant Skinner at Juno College</p>
    </div>
  )
}

export default Footer;